import lazyLoading from './config';
import ErrorRouter from './error.router';
import ApiDocRouter from './apiDoc.router';
import ControlRouter from './control.router';

const routers = [
    {
        path: '/docCenter/:slug?',
        name: 'docCenter.detail',
        meta: {
            title: '文档中心'
        },
        component: resolve => lazyLoading(resolve, 'docCenter')
    },
    {
        path: '/notice/:slug?',
        name: 'notice.detail',
        meta: {
            title: '平台公告'
        },
        component: resolve => lazyLoading(resolve, 'notice')
    },
    {
        path: '/trade',
        redirect: {
            path: '/',
            query: { docType: '1', id: '241' }
        }
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: resolve => lazyLoading(resolve, 'login')
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '注册'
        },
        component: resolve => lazyLoading(resolve, 'register')
    },
    {
        path: '/sign',
        name: 'sign',
        meta: {
            title: '生成签名'
        },
        component: resolve => lazyLoading(resolve, 'sign')
    },
    {
        path: '*',
        redirect: '/404'
    },
    ...ErrorRouter,
    ...ApiDocRouter,
    ...ControlRouter
];

export default routers;
